export default "__VITE_ASSET__473f44ed__"